import type { JSX } from 'react';
import { useT } from '../i18n/useT';
import { LockIcon } from './MonthGridView';

/** `locked`: the calendar has fully booked nights, so their swatch is explained. */
export const Legend = ({ locked = false }: { locked?: boolean }): JSX.Element => {
  const t = useT();
  return (
    <ul className="ow-legend" aria-label={t('Legend')}>
      <li>
        <i className="ow-swatch ow-swatch--own" aria-hidden="true" />
        {t('Own use')}
      </li>
      <li>
        <i className="ow-swatch ow-swatch--rental" aria-hidden="true" />
        {t('Rental')}
      </li>
      <li>
        <i className="ow-swatch ow-swatch--block" aria-hidden="true" />
        {t('Maintenance')}
      </li>
      {locked && (
        <li>
          <i className="ow-swatch ow-swatch--locked" aria-hidden="true">
            <LockIcon />
          </i>
          {t('Fully booked')}
        </li>
      )}
      <li>
        <i className="ow-swatch ow-swatch--free" aria-hidden="true" />
        {t('Free')}
      </li>
    </ul>
  );
};
